<template>
  <v-row align="center" two-line>
    <v-col
      :draggable="true"
      cols="12"
      v-for="session in course.courseTopics"
      :key="session.id"
    >
      <course-topic
        :course="course"
        :courseTopic="session"
        :courseMaterials="course.courseMaterials"
        @deleted="deletedTopic"
      />
    </v-col>
    <v-col cols="12" justify="center">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col>
              <edit-course-topic
                :iconSize="36"
                activatorIcon="mdi-plus-circle-outline"
                @saved="savedTopic"
                :courseId="course.id"
              />Add a new topic
            </v-col>
            <v-col>
              <choose-course-topic
                :iconSize="36"
                :subject="course.subject"
                :grade="course.grade"
                :filterCourses="[course]"
                @selectedTopics="copySelectedTopics"
              />Choose topics from other courses
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
const CourseTopic = () => import("@/components/course/CourseTopic.vue");
const ChooseCourseTopic = () =>
  import("@/components/course/ChooseCourseTopic.vue");
const EditCourseTopic = () => import("@/components/course/EditCourseTopic.vue");

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  components: {
    CourseTopic,
    ChooseCourseTopic,
    EditCourseTopic,
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage", "addSuccessMessage"]),
    savedTopic(topic) {
      const courseTopic = { id: topic["topic_courseTopic"].id, topic: topic };
      this.course.courseTopics.push(courseTopic);
    },
    deletedTopic(courseTopic) {
      const deletedIndex = this.course.courseTopics.findIndex(
        (ct) => ct.id == courseTopic.id
      );
      this.course.courseTopics.splice(deletedIndex, 1);
    },
    copySelectedTopics(topics) {
      console.log(topics);
      const srcTopicIds = topics.map((t) => t.id);
      // const data = {
      //   srcTopicIds
      // }
      const params = {
        targetCourseId: this.course.id,
      };
      console.log(params);
      this.$axios
        .post("/course/copy-topics", srcTopicIds, { params })
        .then((resp) => {
          const courseTopics = resp.data;
          this.course.courseTopics = [
            ...this.course.courseTopics,
            ...courseTopics,
          ];
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
  },
};
</script>

<style>
</style>